/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCart: {
  name: 'cart';
  data: string;
} = {
  name: 'cart',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1A.5.5 0 0 1 1 .5h1.18a1.5 1.5 0 0 1 1.471 1.206L4.01 3.5h9.664a1.5 1.5 0 0 1 1.443 1.912l-1.429 5a1.5 1.5 0 0 1-1.442 1.088H5.82a1.5 1.5 0 0 1-1.471-1.206L3.112 4.108a.487.487 0 0 1-.004-.019L2.67 1.902a.5.5 0 0 0-.49-.402H1A.5.5 0 0 1 .5 1Zm3.71 3.5 1.12 5.598a.5.5 0 0 0 .49.402h6.426a.5.5 0 0 0 .48-.363l1.429-5a.5.5 0 0 0-.48-.637H4.21ZM13 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
